import { useMemo } from "react";
import { openChartURL } from "utils/common";
import { Button, Tooltip } from "antd";
import { is } from "date-fns/locale";
import { CHART_STATUS } from "utils/enums";
import {
  CheckCircleOutlined,
  ExclamationCircleOutlined,
} from "@ant-design/icons";
function FillChartBtn({ chart, orderId, lineItemId, customer }) {
  const {
    isPhysicalHistoryExpired,
    isConsentExpired,
    intakeFormSubmitted,
    isConsentFormSubmitted,
  } = customer || {};

  const chartHasValue = chart?.data?.valueJSON ? true : false;
  const status = chart?.data?.status || CHART_STATUS.open;

  const text = useMemo(() => {
    if (!customer) {
      return "Customer information not loaded yet.";
    }

    let text = "";

    if (chartHasValue) return "";

    if (isPhysicalHistoryExpired) {
      text = "Physical History is expired. ";
    } else if (!intakeFormSubmitted) {
      text = "Intake form is not submitted. ";
    }
    if (isConsentExpired) {
      text += "Consent is expired. ";
    } else if (!isConsentFormSubmitted) {
      text += "Consent form is not submitted. ";
    }

    return text;
  }, [
    customer,
    isPhysicalHistoryExpired,
    isConsentExpired,
    intakeFormSubmitted,
    isConsentFormSubmitted,
    chartHasValue,
  ]);

  return (
    <Tooltip title={text} >
      <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
        <Button
          type="text"
          style={{ padding: 0 }}
          disabled={
            !customer ||
            chart?.isLoading ||
            !chart?.data?.chartId ||
            ((isPhysicalHistoryExpired ||
              isConsentExpired ||
              !intakeFormSubmitted ||
              !isConsentFormSubmitted) &&
              status === CHART_STATUS.open)
          }
          onClick={() => {
            openChartURL(orderId, lineItemId, {
              isLegacy: chart?.data?.isLegacy,
              productName: chart?.data?.legacyChartName,
            });
          }}
          loading={chart?.isLoading || !customer}
        >
          {status === CHART_STATUS.completed ? "View Chart" : "Fill Chart"}
        </Button>
        <div style={{ display: "flex", alignItems: 'center', gap: 4 }}>
          {chart?.data?.staffSignedOffDate && <CheckCircleOutlined style={{ color: 'green' }} />}
        </div>

      </div>

    </Tooltip>
  );
}

export default FillChartBtn;
